import axios from '@/utils/request.js'

export const getCylinderInfoMess = cylinderId => {
  // 钢瓶明细查询
  return axios.get(`/goods/gas/cylinder/getCylinderInfoMessById/${cylinderId}`)
}
export const getCylinderTrackList = params => {
  // 查询钢瓶流通轨迹
  return axios.post('/goods/gas/cylinder/getCylinderTrackList/', params)
}
export const getCustomerMessInfolist = id => {
  //  钢瓶明细列表
  return axios.get(`/goods/bGlmCylinderCurrentStatus/getCustomerMessInfolist/${id}`)
}

export const getCustomerTypeMessInfolist = params => {
  // 按类别查询钢瓶明细列表
  return axios.post('/goods/bGlmCylinderCurrentStatus/getCustomerTypeMessInfolist/', params)
}
export const getCyGroupList = companyId => {
  // 钢瓶组列表
  return axios.post('/goods/gas/cylinder/group/getCyGroupList', { companyId })
}
export const queryCyList = params => {
  // 查询钢瓶
  return axios.post('/goods/gas/cylinder/group/queryCyList', params)
}
export const saveCyGroupInfo = params => {
  // 添加钢瓶组
  return axios.post('/goods/gas/cylinder/group/saveCyGroupInfo', params)
}
export const updateCyGroupInfo = params => {
  // 更新钢瓶组
  return axios.post('/goods/gas/cylinder/group/updateCyGroupInfo', params)
}
export const getCyGroupInfo = cgId => {
  // 钢瓶组详细
  return axios.post('/goods/gas/cylinder/group/getCyGroupInfo', { cgId })
}
export const deleteCyGroupInfo = cgId => {
  // 删除钢瓶组
  return axios.post('/goods/gas/cylinder/group/deleteCyGroupInfo', { cgId })
}
export const queryCyListByUUid = params => {
  // 查询钢瓶
  return axios.post('/goods/gas/cylinder/group/queryCyInfoByUuid', params)
}
